import router from '@/modules/tickets/router'

export default {
  router,
}
